package br.com.logicalside.proposes.components.sections

import Res
import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.toSitePalette
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.style.vars.color.ColorVar
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Box(FooterStyle.toModifier().then(modifier), contentAlignment = Alignment.Center) {
        Column {
            Row(
                modifier = Modifier.fillMaxWidth().margin(bottom = 1.cssRem),
                horizontalArrangement = Arrangement.Center
            ) {
                Link(
                    "/terms",
                    Res.string.terms_of_use,
                    Modifier.setVariable(ColorVar, Color.white).whiteSpace(WhiteSpace.NoWrap),
                    variant = UncoloredLinkVariant
                )

                Span(Modifier.padding(leftRight = 1.8.cssRem).toAttrs())

                Link(
                    "/privacy-policy",
                    Res.string.privacy_policy,
                    Modifier.setVariable(ColorVar, Color.white).whiteSpace(WhiteSpace.NoWrap),
                    variant = UncoloredLinkVariant
                )
            }

            SpanText(Res.string.copyright, Modifier.textAlign(TextAlign.Center))
        }
    }
}

val FooterStyle = CssStyle.base {
    val sitePalette = colorMode.toSitePalette()
    Modifier
        .background(sitePalette.brand.primary)
        .padding(topBottom = 1.5.cssRem, leftRight = 10.percent)
        .fontSize(FontSize.Small)
        .color(sitePalette.neutral.n40)
}
